exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".business{background-color:#f6f8f9 !important}.business-hours p{font-weight:500;margin:0}.business-hours.MuiPaper-root{background-color:inherit !important}.business-hours.MuiExpansionPanel-root::before{display:none}.business-hours.MuiPaper-elevation1{box-shadow:none}.business-hours .MuiExpansionPanelSummary-content{flex-grow:0}.business-hours .MuiExpansionPanelDetails-root p{font-size:1rem}.business-hours .summary-details-business-time{color:#818181}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/Appointment/BusinessHours.scss
// module id = 1802
// module chunks = 101